<div class="read-unread-block" *ngIf="!history" [ngClass]="{'not-readed': !readStatus}" (click)="toggleReadStatus($event)">
	<div class="visual-nfs-zone">

	</div>

</div>

<div class="nfs-block">
	<div class="avatar-box">
		<div class="word-avatar" style.background-color="#{{userNfs.notification.sender?.bgColor}}">
			<div class="short-name">
				{{userNfs.notification.sender?.shortCode}}
			</div>
		</div>
		<!-- <div class="indicator" *ngIf="!readStatus && !history" (click)="toggleReadStatus()"></div> -->
	</div>
	<div class="message-box">
		<div class="nf-message" [innerHtml]="statusMessage"></div>
		<!-- <div class="nf-message">{{notificationData.message}}</div> -->

		<div class="nf-time">{{timeToShow}}</div>
	</div>
</div>

<!-- <div [innerHtml]="safeHtml"></div> -->
